export default class CustomTabs {
  constructor(element) {
    this.element = element;
    this.build();
    this.ready();
  }

  build() {
    this.createWrapperElements();
    this.sortElements();
    this.moveMoreWrapperToEnd();
    this.createTabsLinks();
    this.activateInitialTab();
    this.addEventListeners();
    this.createLoadMoreButton();
    this.checkMoreWrapperViewRows();
  }

  // eslint-disable-next-line class-methods-use-this
  createTabsLinks() {
    const tabsWrapper = document.getElementById('tabs-wrapper');
    const yearWrappers = document.getElementById('year-wrappers');

    for (let i = 0; i < yearWrappers.children.length; i += 1) {
      const yearWrapper = yearWrappers.children[i];
      const year = yearWrapper.id.split('-').pop();
      const tab = document.createElement('div');
      tab.classList.add('year-button', yearWrapper.id);
      tab.textContent = year;

      tabsWrapper.appendChild(tab);
    }
  }

  // eslint-disable-next-line class-methods-use-this
  getCurrentYear() {
    return new Date().getFullYear();
  }

  // eslint-disable-next-line class-methods-use-this
  createLoadMoreButton() {
    const loadMoreButton = document.createElement('button');
    const moreWrapper = document.getElementById('wrapper-more');
    let startIndex = 20;
    const rowsPerPage = 20;

    loadMoreButton.setAttribute('id', 'load-more-button');
    loadMoreButton.textContent = 'Load more';
    loadMoreButton.addEventListener('click', () => {
      const rows = moreWrapper.querySelectorAll('.views-row');
      for (let i = startIndex; i < Math.min(startIndex + rowsPerPage, rows.length); i += 1) {
        rows[i].classList.add('active');
      }
      startIndex += rowsPerPage;

      // Check if all rows have the 'active' class
      const remainingRows = moreWrapper.querySelectorAll('.views-row:not(.active)');
      if (remainingRows.length === 0) {
        loadMoreButton.style.display = 'none';
      }
    });

    moreWrapper.appendChild(loadMoreButton);
  }


  // eslint-disable-next-line class-methods-use-this
  createWrapperElements() {
    const container = this.element.querySelector('.view-content');

    const tabsWrappers = document.createElement('div');
    tabsWrappers.setAttribute('id', 'tabs-wrapper');
    container.appendChild(tabsWrappers);

    const yearWrappers = document.createElement('div');
    yearWrappers.setAttribute('id', 'year-wrappers');
    container.appendChild(yearWrappers);

    const moreWrapper = document.createElement('div');
    moreWrapper.setAttribute('id', 'wrapper-more');
    moreWrapper.classList.add('year-wrapper');
    yearWrappers.appendChild(moreWrapper);
  }

  // eslint-disable-next-line class-methods-use-this
  getLatestYear() {
    let latestYear = 0;
    const viewsRows = this.element.querySelectorAll('.views-row');

    viewsRows.forEach((row) => {
      const timeElement = row.querySelector('time');
      if (timeElement) {
        const year = new Date(timeElement.getAttribute('datetime')).getFullYear();
        if (year > latestYear) {
          latestYear = year;
        }
      }
    });

    return latestYear;
  }

  sortElements() {
    // const currentYear = this.getCurrentYear();
    const latestYear = this.getLatestYear();
    const oldestYear = latestYear - 4;

    const viewsRows = this.element.querySelectorAll('.views-row');
    const yearWrappers = document.getElementById('year-wrappers');
    const moreWrapper = document.getElementById('wrapper-more');
    let count = 0;

    viewsRows.forEach((row) => {
      const timeElement = row.querySelector('time');

      if (timeElement) {
        const datetime = timeElement.getAttribute('datetime');
        const year = new Date(datetime).getFullYear();

        if (year >= oldestYear && year <= latestYear) {
          // Place within yearWrappers
          let yearWrapper = yearWrappers.querySelector(`#year-wrapper-${year}`);
          if (!yearWrapper) {
            yearWrapper = document.createElement('div');
            yearWrapper.setAttribute('id', `year-wrapper-${year}`);
            yearWrapper.setAttribute('class', 'year-wrapper');
            yearWrappers.appendChild(yearWrapper);
          }
          yearWrapper.appendChild(row);
        } else {
          if (count < 20) {
            row.classList.add('active');
          }
          // Place within moreWrapper
          moreWrapper.appendChild(row);
          count += 1;
        }
      }
    });
  }

  // eslint-disable-next-line class-methods-use-this
  activateInitialTab() {
    const firstTabButton = document.querySelector('#tabs-wrapper .year-button');
    if (firstTabButton) {
      firstTabButton.classList.add('active');

      const correspondingYearWrapperId = firstTabButton.classList[1];
      const correspondingYearWrapper = document.getElementById(correspondingYearWrapperId);
      if (correspondingYearWrapper) {
        correspondingYearWrapper.classList.add('active');
      }
    }
  }

  // eslint-disable-next-line class-methods-use-this
  addEventListeners() {
    const yearButtons = document.querySelectorAll('.year-button');
    yearButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const currentActiveButton = document.querySelector('.year-button.active');
        if (currentActiveButton) {
          currentActiveButton.classList.remove('active');
        }
        button.classList.add('active');

        const correspondingYearWrapperId = button.classList[1];
        const correspondingYearWrapper = document.getElementById(correspondingYearWrapperId);
        if (correspondingYearWrapper) {
          const currentActiveYearWrapper = document.querySelector('.year-wrapper.active');
          if (currentActiveYearWrapper) {
            currentActiveYearWrapper.classList.remove('active');
          }
          correspondingYearWrapper.classList.add('active');
        }
      });
    });
  }

  // eslint-disable-next-line class-methods-use-this
  moveMoreWrapperToEnd() {
    const yearWrappers = document.getElementById('year-wrappers');
    const moreWrapper = document.getElementById('wrapper-more');
    yearWrappers.appendChild(moreWrapper);
  }

  // eslint-disable-next-line class-methods-use-this
  checkMoreWrapperViewRows() {
    const moreWrapper = document.getElementById('wrapper-more');
    const rows = moreWrapper.querySelectorAll('.views-row');
    const buttonMore = document.querySelector('.year-button.wrapper-more');

    if (rows.length === 0) {
      buttonMore.style.display = 'none';
    }
  }

  ready() {
    this.element.classList.add('ready');
  }
}
